import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'
import Login from '@/components/Login'
import mainpro from '@/components/mainpro'
import maincompany from '@/components/maincompany'
import uploadclass from '@/components/uploadclass'
import personmanage from '@/components/personmanage'
import missioncenter from '@/components/missioncenter'
import missioncenterlist from '@/components/missioncenterlist'
import addnews from '@/components/addnews'
import userdetails from '@/components/userdetails'
import userdata from '@/components/userdata'
import classdata from '@/components/classdata'
import examcenter from '@/components/examcenter'
import examcenteradd from '@/components/examcenteradd'
import examcenterlist from '@/components/examcenterlist'
import admin from '@/components/admin'
import group from '@/components/group'
import datacenter1 from '@/components/datacenter1'
import datacenter2 from '@/components/datacenter2'
import datacenter3 from '@/components/datacenter3'
import datacenter4 from '@/components/datacenter4'
import datacenter5 from '@/components/datacenter5'
import datacenter6 from '@/components/datacenter6'
import wifilist from '@/components/wifilist'
import persondesc from '@/components/persondesc'
import signup from '@/components/signup'
import examfinish from '@/components/examfinish'
import wenjuan from '@/components/wenjuan'
import shoping from '@/components/shoping'
import Sortable from 'sortablejs'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/Index',
      name: 'Index',
      component: Index,
      children:[
        {//学习中心
          path:'mainpro',
          name:'mainpro',
          meta:{title:'学习中心'},
          component:mainpro
        },
        {//企业中心
          path:'maincompany',
          name:'maincompany',
          meta:{title:'企业中心'},
          component:maincompany
        },
        {//添加课程
          path:'uploadclass',
          name:'uploadclass',
          meta:{title:'添加课程'},
          component:uploadclass
        },
        {//人员管理
          path:'personmanage',
          name:'personmanage',
          meta:{title:'人员管理'},
          component:personmanage
        },
        {//任务中心
          path:'missioncenter',
          name:'missioncenter',
          meta:{title:'任务中心'},
          component:missioncenter
        },
        {
          path:'missioncenterlist',
          name:'missioncenterlist',
          meta:{title:'完成情况'},
          component:missioncenterlist
        },
        {
          path:'addnews',
          name:'addnews',
          meta:{title:'新增资讯'},
          component:addnews
        },
        {
          path:'userdetails',
          name:'userdetails',
          meta:{title:'学习报告'},
          component:userdetails
        },
        {//学员数据
          path:'userdata',
          name:'userdata',
          meta:{title:'学员数据中心'},
          component:userdata
        },
        {//课程数据
          path:'classdata',
          name:'classdata',
          meta:{title:'课程数据'},
          component:classdata
        },
        {//考核中心
          path:'examcenter',
          name:'examcenter',
          meta:{title:'考核中心'},
          component:examcenter
        },
        {//考核中心
          path:'examcenteradd',
          name:'examcenteradd',
          meta:{title:'添加考试'},
          component:examcenteradd
        },
        {//考核中心
          path:'examcenterlist',
          name:'examcenterlist',
          meta:{title:'添加考试'},
          component:examcenterlist
        },
        {//考核中心
          path:'admin',
          name:'admin',
          meta:{title:'账号管理'},
          component:admin
        },
        {//论坛管理
          path:'group',
          name:'group',
          meta:{title:'论坛管理'},
          component:group
        },
        {//数据中台1
          path:'datacenter1',
          name:'datacenter1',
          meta:{title:'课程数据'},
          component:datacenter1
        },
        {//数据中台2
          path:'datacenter2',
          name:'datacenter2',
          meta:{title:'任务数据'},
          component:datacenter2
        },
        {//数据中台3
          path:'datacenter3',
          name:'datacenter3',
          meta:{title:'考试数据'},
          component:datacenter3
        },
        {//数据中台4
          path:'datacenter4',
          name:'datacenter4',
          meta:{title:'学员档案'},
          component:datacenter4
        },
        {//数据中台5
          path:'datacenter5',
          name:'datacenter5',
          meta:{title:'日志统计'},
          component:datacenter5
        },
        {//数据中台6
          path:'datacenter6',
          name:'datacenter6',
          meta:{title:'组织档案'},
          component:datacenter6
        },
        {//数据中台6
          path:'wifilist',
          name:'wifilist',
          meta:{title:'WIFI管理'},
          component:wifilist
        },
        {//数据中台6
          path:'persondesc',
          name:'persondesc',
          meta:{title:'个人信息'},
          component:persondesc
        },
        {//数据中台6
          path:'signup',
          name:'signup',
          meta:{title:'报名管理'},
          component:signup
        },
        {//数据中台6
          path:'examfinish',
          name:'examfinish',
          meta:{title:'查看考试答案'},
          component:examfinish
        },
        {//数据中台6
          path:'wenjuan',
          name:'wenjuan',
          meta:{title:'留言反馈'},
          component:wenjuan
        },
        {//数据中台6
          path:'shoping',
          name:'shoping',
          meta:{title:'商城管理'},
          component:shoping
        },
      ]
    },
    {
      path: '/Login',
      name: 'Login',
      component: Login
    }
    ,
    {
      path:'/Index',
      redirect:'/Index/personmanage'
    }
    // ,
    // {
    //   path:'*',
    //   redirect:{path:'/Login'}
    // }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js